import React from 'react';
import {percentageFormatter} from 'azshared';
import './percentage-bar.scss';

export interface PercentageBarProps {
  percentage: number;
  visualPercentage?: number;
  title: string;
  xLegend?: string;
  yLegend?: string;
  start?: number;
  end?: number;
  step?: number;
  disabled?: boolean;
  showValue?: boolean;
  formatted?: boolean;
  isPercentage?: boolean;
}

export const PercentageBar = (props: PercentageBarProps) => {
  const {
    xLegend,
    yLegend,
    disabled = false,
    showValue = false,
    percentage,
    visualPercentage,
    title,
    start = 0,
    end = 100,
    step = 100,
    formatted = false,
    isPercentage = false
  } = props;
  
  const effectivePercentage = visualPercentage !== undefined 
    ? visualPercentage 
    : (isPercentage ? percentage * 100 : percentage);

  const paddingLeft = `${effectivePercentage}%`;
  const width = `${effectivePercentage}%`;
  const formattedValue = formatted ? percentageFormatter(percentage, { isPercentage: isPercentage }) : percentage;

  const percentageBarProgress: number[] = [];
  for (let i = start; i <= end; i += step) percentageBarProgress.push(i);

  return (
    <div className='percentage-bar-container'>
      <div className='title'>{title}</div>
      {showValue && (
        <div style={{ paddingLeft }} className={'parcentage-bar-show-value'}>
          {formattedValue}{' '}
        </div>
      )}
      <div className='percentage-container'>
        {yLegend && <div className='percentage-bar-yLegend'>{yLegend}</div>}

        <div className='percentage-bar__outer'>
          <div className={'percentage-bar__inner' + (disabled ? '__disabled' : '')} style={{ width }} />
        </div>
      </div>
      <div className={'percentage-bar-scale' + (yLegend ? '__legend' : '')}>
        {percentageBarProgress.map((n, i) => (
          <div className='percentage-bar-number' key={'percentage-bar-number_' + i}>
            {formatted ? percentageFormatter(n, { isPercentage: isPercentage }) : n}
          </div>
        ))}
      </div>
      {xLegend && <div className={'percentage-bar-xLegend' + (yLegend ? '__legend' : '')}>{xLegend}</div>}
    </div>
  );
};
